<div class="p-0 p-md-8">
  <app-custom-table [jobs]="jobs" [columns]="columns" [filters]="filters" [searchKey]="searchKey"
    [title]="'Job Vacancies' | translate" [postButtonLabel]="'Post Vacancy' | translate" [pageSize]="pageSize"
    [serverSidePagination]="true" [totalElements]="totalElements" [serverPage]="currentPage + 1"
    (postClicked)="onPostVacancy()" (filterChanged)="onFilterChanged($event.key, $event.value)"
    (editClicked)="onEdit($event)" (viewClicked)="onView($event)" (pageChanged)="onPageChanged($event)"
    (searchChanged)="onSearchChange($event)" [externalSearchQuery]="searchQuery"
    (actionClicked)="onActionClicked($event)">
  </app-custom-table>
</div>